import utm from "@segment/utm-params";
import Cookies from "js-cookie";

type UtmObject = {
  source: string | null;
  medium: string | null;
  term: string | null;
  content: string | null;
  name: string | null;
};

const emptyUtmObject: UtmObject = {
  source: null,
  medium: null,
  term: null,
  content: null,
  name: null,
};

export const updateUtm = (query: string) => {
  if (!query) {
    return;
  }

  const utmObject = utm.strict(window.location.search);

  if (Object.keys(utmObject).length) {
    Cookies.set("hoopla_utm", JSON.stringify(utmObject), {
      expires: 1,
      path: "/",
    });
  }
};

export const getUtm = (): UtmObject => {
  try {
    const utmObject = JSON.parse(Cookies.get("hoopla_utm") || "{}");

    return Object.keys(emptyUtmObject).reduce(
      (acc, key) =>
        Object.assign(
          {
            ...acc,
          },
          {
            [key]: utmObject[key] || null,
          },
        ),
      {} as UtmObject,
    );
  } catch (err) {
    return { ...emptyUtmObject };
  }
};
	